<template>
    <div>
        <pxkeji-rightHeader/>

        <div class="pxkeji-right-box">
            <a-tabs default-active-key="setting">
                <a-tab-pane key="setting" tab="基本设置">
                    <a-form :form="form" @submit="settingSubmit">
                       <a-form-item
                                label="Logo设置"
                                :label-col="{ span: 5 }"
                                :wrapper-col="{ span: 19 }"
                                class="is-required"
                        >
                         <a-upload
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :action="$api.file.uploadFile"
                            :multiple="false"
                            :beforeUpload="beforeUpload"
                            @change="handleChangeLogo"
                          >
                            <img v-if="info.setting.logo"alt="example" style="width: 100%" :src="info.setting.logo" />
                            <div v-else>
                                <a-icon type="plus"/>
                                <div class="ant-upload-text">Upload</div>
                            </div>
                        </a-upload>
                        <p style="color:red;">logo比例  5：1</p>
                        </a-form-item>

                        <a-form-item label="电话" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入电话"
                                    v-decorator="[
              'telephone',
              {rules: [{ required: true, message: '请输入电话!' }],initialValue:info.setting.telephone}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item
                                label="电话图标设置"
                                :label-col="{ span: 5 }"
                                :wrapper-col="{ span: 19 }"
                                class="is-required"
                        >
                        <a-upload
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :action="$api.file.uploadFile"
                            :multiple="false"
                            :beforeUpload="beforeUpload"
                            @change="handleChangeIcon"
                          >
                            <img v-if="info.setting.telicon"alt="example" style="width: 100%" :src="info.setting.telicon" />
                            <div v-else>
                                <a-icon type="plus"/>
                                <div class="ant-upload-text">Upload</div>
                            </div>
                        </a-upload>
                        <p style="color:red;">电话图标比例  1：1</p>
                        </a-form-item>
                        <a-form-item :wrapper-col="{ span: 24, offset: 5 }" style="margin-top:20px;">
                            <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
                        </a-form-item>
                    </a-form>
                </a-tab-pane>
                <a-tab-pane key="custom" tab="首页自定义板块" force-render>
                    <a-form :form="form1" @submit="customSubmit">
                        <a-form-item label="板块标题" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入板块标题"
                                    v-decorator="[
                                  'title',
                                  {rules: [{ required: true, message: '请输入板块标题!' }],initialValue:info.custom.title}
                                ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="板块描述" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-textarea placeholder="请输入板块板块描述" auto-size  
                            v-decorator="[
                                  'remark',
                                  {rules: [{ required: true, message: '请输入板块板块描述!' }],initialValue:info.custom.remark}
                                ]"/>
                        </a-form-item>
                        <a-form-item label="板块分类" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-button type="primary" @click="AddCustom" v-show="butshow">添加</a-button>
                             <a-table
                                :columns="columns"
                                :dataSource="info.custom.list"
                                rowKey="index"
                                @change="onChange"
                                :loading="isloading"
                                :locale="{emptyText:'暂无数据'}"
                              >
                                <span slot="action" slot-scope="action">
                                  <pxkeji-btn name="编辑" @click="showInfo(action)" size="small" type="primary"/>
                                </span>
                            </a-table>
                        </a-form-item>
                        <a-form-item :wrapper-col="{ span: 24, offset: 5 }" style="margin-top:20px;">
                            <pxkeji-btn name="确认" type="primary" htmlType="submit"/>
                        </a-form-item>
                    </a-form>
                </a-tab-pane>
            </a-tabs>
        </div>
        <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
      @infoChange=""
      ref="addInfo"
    >
      <Info @callbackMethod="save" :infos="addedit.info" />
    </a-modal>
    </div>
</template>
<script>
    var that;
    import Info from "./websiteCustomInfo.vue"; //新增编辑
    const columns = [
      
      {
        dataIndex: "name",
        key: "name",
        align: "center",
        title: "名称",
      },
      {
        dataIndex: "img",
        key: "img",
        align: "center",
        title: "图片",
        width: 400,
      },
      {
        dataIndex: "articleId",
        key: "articleId",
        align: "center",
        title: "文章编号"
      },
      {
        title: "操作",
        key: "action",
        align: "center",
        scopedSlots: { customRender: "action" }
      }
    ];
    export default {
        name: "websiteSetting",
        data() {
            return {
                form: this.$form.createForm(this),
                form1: this.$form.createForm(this),
                isloading: false,
                loadingTip: "加载中...",
                articleList:[],
                columns, //表头
                butshow:true,
                addedit: {
                    title: "",
                    info: {},
                    visible: false
                  },
                info: {
                    setting: {
                        logo: "",
                        telephone: "",
                        telicon: "",
                    },
                    custom: {
                        title:"",
                        remark:"",
                        list:[
                        ],
                    },
                },
            };
        },
        components: {
            Info: Info
          },
        mounted: function () {
            this.$nextTick(function () {
                that = this;
                this.getSetting();
                this.getcustomSetting();
            });
        },
        watch: {},
        methods: {
            getSetting(){
                this.isloading = true;
                this.$api.systemSetting
                .getSettingBykey({key:'setting'})
                .then((res) => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        if(res.data){
                            this.info.setting=res.data;
                        }
                    } else {
                        this.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
            },
            getcustomSetting(){
                this.isloading = true;
                this.$api.systemSetting
                .getSettingBykey({key:'customSetting'})
                .then((res) => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        if(res.data){
                            this.info.custom=res.data;
                            if(this.info.custom.list.length >= 4){
                                this.butshow=false;
                            }else{
                                this.butshow=true;
                            }
                        }
                        
                    } else {
                        this.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
            },
            settingSubmit(e){
                e.preventDefault();
                this.form.validateFields((err, values) => {
                  
                  if (!err) {
                    this.info.setting.telephone=values.telephone
                    var params={
                        key:'setting',
                        data:this.info.setting,
                    };
                    this.isloading = true;
                    this.$api.systemSetting
                            .setSettingBykey(params)
                            .then((res) => {
                              this.isloading = false;
                              if (res.errorCode == that.$msg.responseCode.success) {
                                this.$message.success(res.errorMsg);
                              } else {
                                this.$message.error(res.errorMsg);
                              }
                            })
                            .catch(() => {
                              this.isloading = false;
                            });
                  }
                });
            },
            customSubmit(e){
                e.preventDefault();
                this.form1.validateFields((err, values) => {
                  
                  if (!err) {
                    console.log(values);
                    this.info.custom.title=values.title
                    this.info.custom.remark=values.remark
                    var params={
                        key:'customSetting',
                        data:this.info.custom,
                    };
                    this.isloading = true;
                    this.$api.systemSetting
                            .setSettingBykey(params)
                            .then((res) => {
                              this.isloading = false;
                              if (res.errorCode == that.$msg.responseCode.success) {
                                this.$message.success(res.errorMsg);
                              } else {
                                this.$message.error(res.errorMsg);
                              }
                            })
                            .catch(() => {
                              this.isloading = false;
                            });
                  }
                });
            },
            AddCustom(){
                if(this.info.custom.list.length < 4){
                    var info={
                        index:this.info.custom.list.length,
                        name:'',
                        img:'',
                        articleId:'',
                    };
                    this.addedit.visible = true;
                    this.addedit.title = "添加";
                    this.addedit.info = info;
                }
            },
            showInfo(info) {
              this.addedit.visible = true;
              this.addedit.title = "编辑";
              this.addedit.info = info;
            },
            save(data) {
                if(this.info.custom.list[data.index]){
                   this.info.custom.list[data.index]=data;
                }else{
                    this.info.custom.list.push(data);
                }
                if(this.info.custom.list.length >= 4){
                    this.butshow=false;
                }else{
                    this.butshow=true;
                }
              this.addedit.visible = false;
            },
            onChange(){
                if(info.custom.list.length >= 4){
                    this.butshow=false;
                }
            },
            handleChangeLogo(info) {
                if (info.file.status === 'done') {
                    this.info.setting.logo=info.file.response.data.path;
                    this.$message.success('文件上传成功');
                } else if (info.file.status === 'error') {
                    this.$message.error('文件上传失败');
                }
            },
            handleChangeIcon(info){
                 if (info.file.status === 'done') {
                    this.info.setting.telicon=info.file.response.data.path;
                    this.$message.success('文件上传成功');
                } else if (info.file.status === 'error') {
                    this.$message.error('文件上传失败');
                }
            },
            beforeUpload(file, fileList) {
              var isJPGPNG = false;
              if (file.type === "image/jpeg" || file.type === "image/png") {
                isJPGPNG = true;
              } else {
                isJPGPNG = false;
                this.$message.error("只能上传jpg/png格式的文件!");
              }
              const isLt2M = file.size / 1024 / 1024 < 2;
              if (!isLt2M) {
                this.$message.error("文件不能超过2MB!");
              }
              return isJPGPNG && isLt2M;
            },
            handleChange(info) {
              if (info.file.status) {
                this.fileList = info.fileList;
              }
            },
            error(msg) {
                this.$error({
                    title: "提示",
                    content: msg == undefined ? "服务器异常" : msg,
                    okText: "返回",
                    centered: true,
                    onOk() {
                        that.$emit("callbackMethod");
                    },
                });
            },
        },
    };
</script>
<style type="text/css">
    .avatar-uploader > .ant-upload {
      width: 128px;
      height: 128px;
    }
    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
</style>


